<div
  #pathBar
  class="path-bar"
  [style.border-color]="getPathBarBorderColor()"
  cdkDropList
  cdkDropListOrientation="horizontal"
  [cdkDropListData]="productionSchedulePath?.pathGroups"
  (cdkDropListDropped)="moveDroppedDrawingToProductionSchedulePath($event)"
>
  <div
    #itemsInPathGroup
    class="path-item"
    *ngFor="let productionScheduleItemInPathGroup of productionSchedulePath?.pathGroups; let productionScheduleItemInPathGroupIndex = index"
    cdkDrag
    (cdkDragStarted)="onRowDrag(productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex)"
    (cdkDragEnded)="draggingStopped()"
    (mouseenter)="openHoverInfoTooltip($event, productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex)"
    (mouseup)="openHoverInfoTooltip($event, productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex)"
    (mouseleave)="closeDialogIfOpen()"
    (click)="openEditProductionScheduleItemDialog($event, productionScheduleItemInPathGroup, productionScheduleItemInPathGroupIndex)"
    [style.width.px]="widthOfPathItems[productionScheduleItemInPathGroupIndex]"
    [ngStyle]="getPathItemStyle(productionScheduleItemInPathGroup)"
    [cdkDragData]="productionScheduleItemInPathGroup"
  ></div>
</div>
<div
  *ngIf="canShowMinimumbuggyLengthIndicator()"
  class="buggy-indicator minimum"
  [style.left.px]="minimumBuggyLengthIndicatorPlace"
  [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MINIMUM_LENGTH' | bmsTranslate"
  matTooltipPosition="left"
></div>
<div
  *ngIf="canShowMaxmimumbuggyLengthIndicator()"
  class="buggy-indicator maximum"
  [style.left.px]="maximumBuggyLengthIndicatorPlace"
  [matTooltip]="'PRODUCTION_ORDER.WEAVE_PLAN.PATH_LAYOUT.MAXIMUM_LENGTH' | bmsTranslate"
  matTooltipPosition="left"
></div>
